import moment from "moment";
import {
  ADD_RIGHT,
  API_URL,
  DELETE_RIGHT,
  PUBLIC_TOKEN,
  PUBLIC_URL,
  UPDATE_RIGHT,
  VIEW_RIGHT,
  VIEWOFOTHER_RIGHT,
} from "./constants";
import numeral from "numeral";
import { isArray, isString } from "lodash";

numeral.register("locale", "vi", {
  delimiters: {
    thousands: ".",
    decimal: ",",
  },
  abbreviations: {
    thousand: "Nghìn",
    million: "Triệu",
    billion: "Tỷ",
    trillion: "Nghìn Tỷ",
  },
  currency: {
    symbol: "₫",
  },
  ordinal: (number) => number + "",
});
numeral.locale("vi");

function formatDateDisplay(date: string | Date, format = "DD/MM/YYYY"): string {
  if (!date || !moment(date).isValid()) return "";
  return moment(date).format(format);
}

// generate search keywords
const generateSearchKeywords = (
  obj: { [key: string]: any },
  stringify: boolean = true
) => {
  let result = "";
  for (let key in obj) {
    result += `${!result ? "?" : "&"}${key}=${
      stringify ? JSON.stringify(obj[key]) : obj[key]
    }`;
  }
  return result;
};

// generate random string
function generateRandomString(length: number) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let randomString = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomString += characters.charAt(randomIndex);
  }

  return randomString;
}

type generateSplitTextType = {
  strings: string[];
  symbol?: string;
};
function generateSplitText({ strings, symbol = "," }: generateSplitTextType) {
  if (!isArray(strings)) {
    return "";
  }
  const result = strings.reduce((acc: string, item: string) => {
    if (!!item) {
      if (!!acc) {
        return `${acc}${symbol} ${item}`;
      } else {
        return item;
      }
    } else {
      return acc;
    }
  }, "");
  return result;
}

// generate link image
const generateLinkImage = (link: string) => {
  return `${PUBLIC_URL}${link}?access_token=${PUBLIC_TOKEN}`;
};

type downloadFileType = {
  link: string;
  successMessage?: string;
};
const downloadFile = ({ link, successMessage }: downloadFileType) => {
  fetch(link)
    .then((response) => response.blob())
    .then((blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "download";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    })
    .catch((error) => console.error("Error downloading file:", error));
};

type groupByType = {
  data: any[];
  callbackMatch: (item: any) => string;
  returnKey?: boolean;
};
const groupBy = ({
  data = [],
  callbackMatch,
  returnKey = false,
}: groupByType) => {
  if (!callbackMatch) return data;
  let result: { [key: string]: any[] } = {};
  data.forEach((item) => {
    if (result[callbackMatch(item)]) {
      result[callbackMatch(item)].push(item);
    } else {
      result[callbackMatch(item)] = [item];
    }
  });
  if (returnKey) {
    return result;
  } else {
    return Object.values(result);
  }
};

function stripHTML(html: string) {
  if (!window.document) {
    return "";
  } else {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || "";
  }
}

function getPlainText(str: string) {
  if (!str) return "";
  return str?.split(" ")?.join("").replaceAll("\n", "");
}
const getAvatar = (email: string, size?: string, token?: string) => {
  if (!email) return "";
  return `${API_URL}/avatar?email=${email}&size=${size || ""}S&access_token=${
    token || PUBLIC_TOKEN
  }`;
};

type allowShowAuthorizeType = {
  module: string | string[];
  rights: {
    module: string;
    [VIEW_RIGHT]: boolean;
    [VIEWOFOTHER_RIGHT]: boolean;
    [ADD_RIGHT]: boolean;
    [UPDATE_RIGHT]: boolean;
    [DELETE_RIGHT]: boolean;
  }[];
};
const allowShowAuthorize = ({ module, rights }: allowShowAuthorizeType) => {
  if (isArray(module)) {
    for (let i = 0; i < module.length; i++) {
      const currentRight = rights.find((r) => r.module === module[i]);
      if (currentRight?.[VIEW_RIGHT] || currentRight?.[VIEWOFOTHER_RIGHT]) {
        return true;
      }
    }
    return false;
  } else if (isString(module)) {
    const existed = rights.find((r) => r.module === module);
    if (existed && (existed[VIEW_RIGHT] || existed[VIEWOFOTHER_RIGHT])) {
      return true;
    }
  }
  return false;
};

export {
  numeral as numeralCustom,
  formatDateDisplay,
  generateSearchKeywords,
  generateRandomString,
  generateLinkImage,
  generateSplitText,
  downloadFile,
  groupBy,
  stripHTML,
  getPlainText,
  getAvatar,
  allowShowAuthorize,
};
